module.exports = __webpack_public_path__ + "static/img/play-singleplayer-square.8d9767f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-singleplayer-square.jpg
// module id = 4ynF
// module chunks = 1